import React from "react";

const KnowledgeSourceDefaultIcon = () => (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="24" cy="24" r="23.5" fill="#F3F3FF" stroke="#DEDFFF" />
  <rect x="22" y="30" width="4" height="4" rx="1" fill="#B0B2FF" />
  <path d="M22 29.6586V32C22 33.1046 22.8954 34 24 34C25.1046 34 26 33.1046 26 32V29.6586M30 24C30 27.3137 27.3137 30 24 30C20.6863 30 18 27.3137 18 24C18 20.6863 20.6863 18 24 18C27.3137 18 30 20.6863 30 24Z" stroke="#4548C4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M15 24H14M17.5 17.5L16.8999 16.8999M30.5 17.5L31.1002 16.8999M34 24H33M24 14V15" stroke="#EF4068" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
</svg>);

export default KnowledgeSourceDefaultIcon;
